export default __webpack_public_path__ + "static/assets/SL-cards-bg-mobile.aa8a3fb6.jpg";